import React from 'react'

const Slider = function slider ({sliderinfo_1,sliderinfo_2,sliderinfo_3,sliderinfo_4,info}){
    return (
        <section className="sliderInfo">
            <div className="container w90 dnone">
                <div className="">
                    <a className="flex">
                    <img src="/img/sendus.svg" alt="🚗"/>
                    <div className="colflex">
                        <h3>{sliderinfo_1.title}</h3>
                        <p>{sliderinfo_1.text}</p>
                    </div>
                    </a>
                </div>
                <div className="">
                    <a href={"tel:+"+info.cellphone} className="flex">
                    <img src="/img/callus.svg" alt="📞"/>
                    <div className="colflex">
                        <h3>{sliderinfo_2.title}</h3>
                        <p>{sliderinfo_2.text}</p>
                    </div>
                    </a>
                </div>
                <div className="">
                    <a target="_blank" href={"https://wa.me/"+info.whatsapp} className="flex">
                    <img src="/img/talkus.svg" alt="🙍‍♂️"/>
                    <div className="colflex">
                        <h3>{sliderinfo_3.title}</h3>
                        <p dangerouslySetInnerHTML={{__html:sliderinfo_3.text}}></p>
                    </div>
                    </a>
                </div>
                <div className="">
                    <a href={"https://www.google.com/maps/place/MONSTER+CAR+AUDIO/@"+info.latitud+","+info.longitud+",17z/data=!3m1!4b1!4m5!3m4!1s0x8ef42d5c62b8c65d:0xb468e689d3cf309e!8m2!3d10.9965078!4d-74.8071029"} className="flex" target="_blank">
                    <img src="/img/findus.svg" alt="🗺"/>
                    <div className="colflex">
                        <h3>{sliderinfo_4.title}</h3>
                        <p>{sliderinfo_4.text}</p>
                    </div>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default Slider
